var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('JerarquiaMedalla',{attrs:{"id":_vm.usuario.jerarquiaId}}),_c('span',[_vm._v(_vm._s(_vm.usuario.nombre))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }